/* Info Component in SeriesPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-1 ${styles.SubTitle6 }`} md={{span: 8, offset: 2 }}>
            <h5 className={`text-center pb-2 ${styles.Red }`} >INDEXSHOTS INFO</h5> 
            <hr className={`mt-2 mb-0`}/>
            <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use Indexshots to preview and explore any 
            aspect of <span className={`${styles.Red}`}>Visual Style</span>, for individual Scenes or the whole Project.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> They can be used to 
              storyboard a <span className={`${styles.Red}`}>sequence</span> in more detail or to preview tones and color 
              through the project.
           </p>
            <p className='mt-2'><span className={`${styles.Red}`}>*</span> Click the Create Series button to create an 
            Indexshot <span className={`${styles.Red}`}>Series</span>.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> Click on a Series to add Images, Sketches or
           Templates to its page.
           </p>
           <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info